import { DatasetEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getDatasets = async (queryString: string): Promise<any> =>
  APIManager.sendGet(DatasetEnds.GET_DATASET(queryString), true, {}, {}, axios);

const getSingleDataset = async (id: any): Promise<any> =>
  APIManager.sendGet(
    `${DatasetEnds.GET_SINGLE_DATASET}/${id}`,
    true,
    {},
    {},
    axios
  );

const createDatasets = async (data: any): Promise<any> =>
  APIManager.sendPost(DatasetEnds.CREATE_DATASET, data, true, {}, {}, axios);

const updateDatasets = async (id: any, data: any): Promise<any> =>
  APIManager.sendPut(DatasetEnds.UPDATE_DATASET(id), data, true, {}, {}, axios);

const deleteDatasets = async (id: string): Promise<any> =>
  APIManager.sendDelete(DatasetEnds.DELETE_DATASET(id), true, {}, {}, axios);

const updateDatasetStatus = async (
  data: any,
  id: string,
  status: string
): Promise<any> =>
  APIManager.sendPut(
    DatasetEnds.UPDATE_DATASET_STATUS(id, status),
    data,
    true,
    {},
    {},
    axios
  );

const getDatasetHistory = async (
  entityType: string,
  entityId: string
): Promise<any> =>
  APIManager.sendGet(
    DatasetEnds.GET_HISTORY(entityType, entityId),
    true,
    {},
    {},
    axios
  );

const bulkCreate = async (data: any): Promise<any> =>
  APIManager.sendPost(DatasetEnds.BULK_UPLOAD, data, true, {}, {}, axios);

export const DatasetsService = {
  getDatasets,
  createDatasets,
  getSingleDataset,
  updateDatasets,
  deleteDatasets,
  updateDatasetStatus,
  getDatasetHistory,
  bulkCreate,
};
